import { DESTROY_SESSION } from './actionTypes';

export const onClear = (isLogged = 0, loginStateUI = 1, isAlreadyLoggedFromAnotherTab = false, tabListSize = 0, activeTab = false) => {
  return { type: DESTROY_SESSION, isLogged, loginStateUI, isAlreadyLoggedFromAnotherTab, tabListSize, activeTab };
};